import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AuthModal, FLOW_NAMES } from 'ggApp/modules/auth/v3';
import {
    signUpWithWelcomeQuizEnabled as signUpWithWelcomeQuizEnabledSelector,
    sitewideBannerFlagData as sitewideBannerFlagDataSelector,
} from 'ggApp/modules/featureFlag/selectors';
import { initDone as initDoneSelector } from 'ggApp/modules/init/selectors';
import { withCookiesManager } from 'ggApp/utils/CookiesManager';
import { authenticatedBasedOnCookies } from 'ggApp/modules/auth/utils';
import { locationPathname as locationPathnameSelector } from 'ggApp/modules/router/selectors';
import SitewideBanner from 'ggApp/shared/components/SitewideBanner';
import loadConfiguration from 'ggApp/utils/configuration/configuration';

import {
    currentLanguage as currentLanguageSelector,
    storeActive as activeStoreSelector,
} from 'ggApp/modules/store/selectors';

import { Wrap, Home, Links, LoggedIn, LoggedOut } from './styled';

const TopContent = ({
    className,
    isLoggedIn,
    isTransparent,
    isDesktopUser,
    signUpWithWelcomeQuizEnabled,
    cookiesManager,
    initDone,
    pathname,
    sitewideBannerFlagData,
    b2cRedirectionModal,
    activeStore,
    locale,
}) => {
    const [modal, setModal] = useState(null);
    const [authFlow, setAuthFlow] = useState(FLOW_NAMES.SIGN_UP_CUSTOMER);
    const { APP_CONFIG } = loadConfiguration();
    const { shopHost: baseUrl } = APP_CONFIG;

    const createModalRef = (authModal) => {
        setModal(authModal);
    };

    const setFlow = (flow) => {
        if (!modal) {
            return;
        }

        setAuthFlow(flow);
        modal.openModal();
    };

    const openSignUpFlow = () => {
        if (pathname?.includes('business')) {
            window.location.assign(
                `${baseUrl}/${activeStore.code}-${locale}/auth?flow=SIGN_UP_BUSINESS`,
            );
        } else if (signUpWithWelcomeQuizEnabled) {
            setFlow(FLOW_NAMES.SIGN_UP_CUSTOMER_WITH_WELCOME_QUIZ);
        } else {
            setFlow(FLOW_NAMES.SIGN_UP_CUSTOMER);
        }
    };

    const openSignInFlow = () => {
        setFlow(FLOW_NAMES.SIGN_IN);
    };

    const renderControls = (optimisticIsLoggedIn) => {
        if (!isDesktopUser) {
            return null;
        }

        if (optimisticIsLoggedIn) {
            return <LoggedIn isTransparent={isTransparent} />;
        }

        return (
            <LoggedOut
                openSignUpFlow={openSignUpFlow}
                openSignInFlow={openSignInFlow}
                isTransparent={isTransparent}
            />
        );
    };

    const optimisticIsLoggedIn = !initDone
        ? authenticatedBasedOnCookies(cookiesManager)
        : isLoggedIn;

    return (
        <>
            {isDesktopUser && sitewideBannerFlagData ? (
                <SitewideBanner sitewideBannerData={sitewideBannerFlagData} />
            ) : null}
            <Wrap className={className}>
                <Home isTransparent={isTransparent} />
                <Links
                    isLoggedIn={optimisticIsLoggedIn}
                    isTransparent={isTransparent}
                    b2cRedirectionModal={b2cRedirectionModal}
                />
                {renderControls(optimisticIsLoggedIn)}
                <AuthModal modalRef={createModalRef} flow={authFlow} />
            </Wrap>
        </>
    );
};

const enhance = compose(
    withCookiesManager,
    connect(
        createStructuredSelector({
            signUpWithWelcomeQuizEnabled: signUpWithWelcomeQuizEnabledSelector,
            initDone: initDoneSelector,
            pathname: locationPathnameSelector,
            sitewideBannerFlagData: sitewideBannerFlagDataSelector,
            activeStore: activeStoreSelector,
            locale: currentLanguageSelector,
        }),
    ),
);

export default enhance(TopContent);
